import { Spinner } from "../Spinner";

const Loading = ({ message = "Bezig met laden...", showSpinner = true }) => (
  <div className="flex gap-5 items-center">
    {showSpinner || (false === showSpinner && !message) ? <Spinner /> : null}
    {message ? <strong>{message}</strong> : null}
  </div>
);

export { Loading };
